export default function ({ store, redirect }) {
  // redirect if the user is not signed in
  if (!store.getters['session/isAuthenticated']) {
    // redirect to sign-in
    return redirect('/sign-in')
  }
}
